import Banner from '../components/Banner.js';
import Footer from '../components/Footer.js';
import resume from '../assets/resume.pdf';

function ResumePage() {
  return (
    <div className="page resume-page">
      <Banner selected="resume" />
      <div className="contents">
        <a href={resume} target="_blank" download rel="noreferrer">
          <button className="download">
            <span>download</span>
          </button>
        </a>
        <div className="container">
          <h1 className="name">BENJAMIN MICHAEL VACHON</h1>
          <div className="contact">
            <p className="left">
              <span>benmvachon@gmail.com</span>
              <span>508-524-8071</span>
            </p>
            <p className="right">
              <span>101 Bellevue Street</span>
              <span>Newton, MA 02458</span>
            </p>
          </div>
          <div className="credentials">
            <div className="credential">
              <p className="label">Skills</p>
              <div className="items">
                <div className="item">
                  <p className="description">
                    <span className="title">Languages</span>
                    <span className="detail">
                      Java, Javascript, SQL, HTML5, CSS3, SASS, C, GraphQL
                    </span>
                  </p>
                </div>
                <div className="item">
                  <p className="description">
                    <span className="title">Libraries</span>
                    <span className="detail">
                      Spring, React, MySql, Node, Maven, Gradle, JQuery, Ember,
                      Angular, Bootstrap, Lucene, Nutch, Solr, Docker,
                      WebSockets, JUnit, Selenium, Chromium
                    </span>
                  </p>
                </div>
                <div className="item">
                  <p className="description">
                    <span className="title">Frameworks</span>
                    <span className="detail">
                      IntelliJ, VSCode, Eclipse, Sublime, vim, ssh, bash, brew,
                      Mac OS, Linux, Jenkins, Git
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="credential">
              <p className="label">Employment</p>
              <div className="items">
                <div className="item">
                  <p className="description">
                    <span className="title">
                      Staff Software Engineer - ServiceNow
                    </span>
                    <span className="detail">
                      Integrated AI Search (formerly Attivio) engine into
                      employee service portal, HR, and ITSM end-user
                      applications offered by ServiceNow by building Seismic
                      framework components connecting to search applications and
                      displaying results.
                    </span>
                    <span className="detail">
                      Developed AI Search Admin Console Experience for managing
                      and configuring search applications across the ServiceNow
                      instance.
                    </span>
                    <span className="detail">
                      Helped connect search to conversational agents as genius
                      results.
                    </span>
                    <span className="detail">
                      Built REST APIs and services connecting to AI Search
                      semantic APIs for retrieval augmented generation used by
                      conversational agents.
                    </span>
                  </p>
                  <p className="date">2021 - Present</p>
                </div>
                <div className="item">
                  <p className="description">
                    <span className="title">
                      Software Engineer - ServiceNow
                    </span>
                    <span className="detail">
                      Stripped down and refitted Attivio&apos;s proprietary
                      search engine to fit within the Service Now ecosystem.
                    </span>
                    <span className="detail">
                      Built Tika service provider into existing ServiceNow
                      machine-learning nodes.
                    </span>
                    <span className="detail">
                      Established high-availability and fallback protocols for
                      Attivio search engine connection from ServiceNow app
                      nodes.
                    </span>
                  </p>
                  <p className="date">2019 - 2021</p>
                </div>
                <div className="item">
                  <p className="description">
                    <span className="title">Software Engineer - Attivio</span>
                    <span className="detail">
                      Connected Apache Nutch to Attivio&apos;s Spring MVC
                      backend framework and ultimately Lucene search index
                      engine to facilitate ingestion of raw web content using a
                      headless chrome browser for javascript execution to render
                      dynamic content before extracting raw text through Apache
                      Tika&apos;s text extraction.
                    </span>
                    <span className="detail">
                      Migrated frontend user experience from Ember to React and
                      enhanced user features.
                    </span>
                  </p>
                  <p className="date">2016 - 2019</p>
                </div>
                <div className="item">
                  <p className="description">
                    <span className="title">Frontend Developer - Attivio</span>
                    <span className="detail">
                      Developed, maintained, and repaired a new Ember.js user
                      experience for search administrators to configure and
                      analyze search applications by connecting via REST APIs to
                      search sources and indexing workflows for content
                      ingestion and query and response workflows for result
                      display configuration.
                    </span>
                  </p>
                  <p className="date">2015 - 2016</p>
                </div>
              </div>
            </div>
            <div className="credential">
              <p className="label">Projects</p>
              <div className="items">
                <div className="item">
                  <p className="description">
                    <span className="title">
                      <a
                        target="_blank"
                        href="https://blorvis.com"
                        rel="noreferrer"
                      >
                        Blorvis
                      </a>
                    </span>
                    <span className="detail">
                      A social-network forum web application that&apos;s a mix
                      between reddit, twitter, myspace, and neopets.
                    </span>
                    <span className="detail">
                      Developed using Docker Compose, MySql, Redis, Rabbitmq,
                      Spring Boot, and React.
                    </span>
                    <span className="detail">
                      See the full codebase on{' '}
                      <a
                        target="_blank"
                        href="https://github.com/benmvachon/bellevue"
                        rel="noreferrer"
                      >
                        GitHub
                      </a>
                      .
                    </span>
                  </p>
                </div>
                <div className="item">
                  <p className="description">
                    <span className="title">
                      <a
                        target="_blank"
                        href="https://www.blaurvis.com"
                        rel="noreferrer"
                      >
                        blaurvis.com
                      </a>
                    </span>
                    <span className="detail">
                      A wedding website allowing invitees to RSVP, play games,
                      and explore easter eggs. Use &ldquo;guest&rdquo; when
                      prompted for a name in order to sign in.
                    </span>
                    <span className="detail">
                      Developed using React and hosted using Firebase.
                    </span>
                  </p>
                </div>
                <div className="item">
                  <p className="description">
                    <span className="title">
                      <a
                        target="_blank"
                        href="https://vagabondvachon.com"
                        rel="noreferrer"
                      >
                        vagabondvachon.com
                      </a>
                    </span>
                    <span className="detail">
                      A travel photography gallery developed for my sister as a
                      gift. Allows a maint user to upload, tag, and manage
                      photos and automatically watermarks them and allows guest
                      users to search photos by keyword and by map location.
                    </span>
                    <span className="detail">
                      Developed using React and hosted using Firebase.
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="credential">
              <p className="label">Education</p>
              <div className="items">
                <div className="item">
                  <p className="description">
                    <span className="title">
                      University of Massachusetts Amherst
                    </span>
                    <span className="detail">
                      Computer Science BS (3.412 GPA)
                    </span>
                  </p>
                  <p className="date">2011 - 2015</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ResumePage;
